import { ReactNode } from 'react';

import { clsx } from 'clsx';
import { LinkProps } from 'next/dist/client/link';
import Link from 'next/link';

import cls from './CustomLink.module.scss';

type LinkVariantType = 'default' | 'contained';
type LinkSizeType = 'auto' | 's' | 'm' | 'l';

type CustomLinkProps = LinkProps & {
  children: ReactNode;
  icon?: ReactNode;
  iconPosition?: 'left' | 'right';
  className?: string;
  variant?: LinkVariantType;
  size?: LinkSizeType;
};

export const CustomLink = ({
  children,
  variant = 'default',
  size = 'auto',
  className,
  iconPosition,
  icon,
  ...rest
}: CustomLinkProps) => {
  return (
    <Link
      {...rest}
      className={clsx(cls.item, className, cls[variant], cls[size], { [cls.withIcon]: icon })}
    >
      {iconPosition === 'left' && icon}
      {children}
      {iconPosition === 'right' && icon}
    </Link>
  );
};
